"use strict";

jQuery.feature_import("js-recycle-module",
  () => require("./recycle.js"),
  mod => mod.feature_js_recycle_module
);